import PropTypes from 'prop-types';
import themeColors from '../assets/styles/themeColors';

import { HeadingSubtitle } from './Heading';
import Paragraph from './Paragraph/Paragraph';

const Header = ({ titleMb, subTitleMb, title, subtitle }) => (
  <>
    <HeadingSubtitle mb={titleMb} color={themeColors.colorTextSecondary}>
      {title}
    </HeadingSubtitle>
    {!!subtitle && (
      <Paragraph mb={subTitleMb} color={themeColors.colorTextXLLight}>
        {subtitle}
      </Paragraph>
    )}
  </>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  titleMb: PropTypes.number,
  subTitleMb: PropTypes.number,
};

export default Header;
